import TYPES from '../../types';

// Domain
import { ActivityEntity } from '../../domain/entities/activity-entity';
import { ActivityRepository } from '../../domain/repository/activity-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchActivitiesQuery extends Query<Array<ActivityEntity>> {
  @Inject(TYPES.CATALOG_ALLIANZ_ACTIVITY_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_ALLIANZ_ACTIVITY_REPOSITORY)
  private readonly repository!: ActivityRepository;

  internalExecute() {
    if (!this.state_manager.state.loaded) {
      this.repository.execute()
        .then((items) => {
          this.state_manager.patch({ items, loaded: true });
        });
    }

    return this.state_manager.state.items;
  }
}
